import { render, staticRenderFns } from "./PortfolioScenarioEditor.vue?vue&type=template&id=e4e9b728"
import script from "./PortfolioScenarioEditor.vue?vue&type=script&lang=ts"
export * from "./PortfolioScenarioEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports